import {dd,store,app} from 'systems/imports'

class BaseProcessor{
  constructor() {}
}
export default BaseProcessor



// WEBPACK FOOTER //
// ./src/processor/BaseProcessor.js